import { gql } from '@apollo/client';

export const QUERY_BET = gql`
  query getBet($id: ID) {
    bet(id: $id) {
      id
      amount
      bet
      betId
      player {
        id
        rewardClaimed
        score
      }
      result
    }
  }
`;

// TODO: Paginate players.  This will only be accurate if the number of players is less than 1000
export const QUERY_PLAYERS = gql`
  query getPlayers($orderBy: String) {
    players(first: 1000, orderBy: $orderBy, orderDirection: desc, where: {
      score_gt: 0
    }) {
      id
      rewardClaimed
      score
    }
  }
`;

export const QUERY_ME = gql`
 query getMe($id: ID) {
  player(id: $id) {
    id
    rewardClaimed
    score
  }
 }
`;

export const QUERY_MY_BETS = gql`
 query getMyBets($player: ID, $first: Int) {
  bets(first: $first, orderBy: "blockNumber", orderDirection: desc, where: {player: $player}) {
    id
    amount
    bet
    blockNumber
    sqmWon
    sqmBurned
    result
  }
 }
`;